import React from "react";
import { Typography } from "@mui/material";

export const SettlementDescription = ({ bill_day, bill_duration, bill_period, bill_date, globalData }) => {
  const toOrdinalSuffix = (num) => {
    const int = parseInt(num, 10);
    const ordinals = ["st", "nd", "rd", "th"];
    const oPattern = [1, 2, 3];
    const tPattern = [11, 12, 13];
    return oPattern.includes(int % 10) && !tPattern.includes(int % 100)
      ? `${int}${ordinals[int % 10 - 1]}`
      : `${int}th`;
  };

  const options = ["First", "Second", "Third", "Fourth", "Fifth"].map((label, index) => ({
    label,
    value: index + 1,
  }));

  const getBillDayLabel = () =>
    globalData?.client_accounts?.bill_day.find((i) => i.value === bill_day)?.label;

  return (
    <>
      {bill_period === 1 && (
        <>
          <Typography color="#171717" fontWeight={600}>{getBillDayLabel()}</Typography>
          <Typography> of every </Typography>
          <Typography color="#171717" fontWeight={600}>{bill_duration}</Typography>
          <Typography color="#171717" fontWeight={600}> weeks</Typography>
        </>
      )}

      {bill_period === 3 && (
        <>
          <Typography>Every </Typography>
          {bill_duration !== 1 && (
            <Typography color="#171717" fontWeight={600}>{bill_duration}</Typography>
          )}
          <Typography color="#171717" fontWeight={600}>{bill_duration !== 1 ? "Days" : "Day"}</Typography>
        </>
      )}

      {bill_period === 2 && bill_date && (
        <>
          <Typography color="#171717" fontWeight={600}>
            {bill_day
              ? options.find((i) => i.value === bill_date)?.label
              : toOrdinalSuffix(bill_date)}
          </Typography>
          {bill_day && <Typography color="#171717" fontWeight={600}>{getBillDayLabel()}</Typography>}
          <Typography> of every </Typography>
          {bill_duration !== 0 && (
            <Typography color="#171717" fontWeight={600}>{bill_duration}</Typography>
          )}
          <Typography color="#171717" fontWeight={600}> Months</Typography>
        </>
      )}
    </>
  );
};